export enum TopbarMode {
  Landing = 'landing',
  Authenticate = 'authenticate',
  Portal = 'portal',
}
